export default __webpack_public_path__ + "static/media/product-image-8.9d7048e2.jpg";